var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{directives:[{name:"show",rawName:"v-show",value:(_vm.showModal),expression:"showModal"}],attrs:{"title":"","okButtonLabel":"Create Layout","modalStyles":{
    maxWidth: 'calc(100% - 2rem)',
    maxHeight: 'calc(100% - 2rem)',
  }},on:{"closeModal":_vm.closeModal},scopedSlots:_vm._u([{key:"body",fn:function(){return [(_vm.isLoading && !_vm.layout)?_c('Loader'):_vm._e(),(_vm.layout)?_c('Layout',{style:(_vm.playerStyle),attrs:{"layout":_vm.layout}}):_vm._e()]},proxy:true},{key:"footer",fn:function(){return [_c('div')]},proxy:true}])})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }